import api from '../../../services/Api';
import { IAuditoriaProvisaoIssResultado } from '../interfaces/IAuditoriaProvisaoIss';

export const AuditoriaProvisaoIssService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaProvisaoIssResultado> {
    const response = await api.get<IAuditoriaProvisaoIssResultado>('auditoria-provisao-iss/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        provisoesAusentes: [],
        mesesConciliados: [],
      }
    );
  },
};
